<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="formData.deviceName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="formData.deviceCode" size="small" disabled style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备厂商：</span>
        </div>
        <el-select v-model="formData.deviceManufacturerCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">设备型号：</span>-->
        <!--</div>-->
        <!--<el-select v-model="formData.deviceModelCode" size="small" style="width: 280px">-->
          <!--<el-option v-for="item in deviceModelList" :key="item.code"-->
                     <!--:label="item.name" :value="item.code">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">所属楼栋：</span>
        </div>
        <el-select v-model="formData.buildingCode" size="small" style="width: 280px">
          <el-option v-for="item in buildingList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">设备位置：</span>
        </div>
        <el-input v-model="formData.deviceLocation" size="small" style="width: 280px" />
      </div>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<span class="line-text">所属楼层：</span>-->
        <!--</div>-->
        <!--<el-select v-model="formData.floorCode" size="small" style="width: 280px">-->
          <!--<el-option v-for="item in floorList" :key="item.code"-->
                     <!--:label="item.name" :value="item.code">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<span class="line-text">责任人：</span>-->
        <!--</div>-->
        <!--<el-select v-model="formData.responsiblePersonCode"-->
                   <!--filterable-->
                   <!--remote-->
                   <!--reserve-keyword-->
                   <!--size="small" style="width: 280px"-->
                   <!--:remote-method="remoteMethod"-->
                   <!--placeholder="请输入关键词查询">-->
          <!--<el-option v-for="item in responsiblePersonList" :key="item._value"-->
                     <!--:label="item._label" :value="item._value">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->


      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../../api/FireControl'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {errorHandler} from '../../../../utils/errorHandler'
  import UploadImgList from '../../../../components/Input/UploadImgList'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'transmission-device-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧消防',
          name: 'fire-over-view'
        }, {
          value: '用传设备'
        }],
        mainTitle: '修改用传设备',
        subheading: '',

        buildingList: [],
        floorList: [],

        deviceManufacturerList: [
          {
            code: '海康',
            name: '海康'
          }, {
            code: '大华',
            name: '大华'
          }
        ],

        deviceModelList: [
          {
            code: 'DM-FC-001',
            name: 'DM-FC-001'
          }
        ],

        formData: {
          deviceName: '',
          deviceCode: '',
          deviceLocation: '',
          deviceManufacturerName: '',
          deviceManufacturerCode: '',
          buildingName: '',
          buildingCode: '',
        },

        responsiblePersonList: [],
      }
    },
    created () {
      this.getBuildingList()

    },
    methods: {
      // 查询用传信息
      getGatewayDeviceByCode (code) {
        this.$axios.get(`${api.getTransmissionDeviceByCode}/${code}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let resData = res.data.data
              this.formData = resData
              this.remoteMethod(this.formData.responsiblePersonName)
            }
          })
          .catch(errorHandler('查询失败'))
      },
      // 获取楼栋列表
      getBuildingList () {
        this.$axios.post(api.getBuildingList, {})
          .then(res => {
            this.buildingList = res.data.data
            this.getGatewayDeviceByCode(this.$route.params.id)
          })
          .catch(errorHandler('获取楼栋列表失败'))
      },

      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },

      // 查询责任人
      getResponsiblePersonList (searchKey) {
        this.$axios.post(api.getResponsiblePerson, {
          searchKey: searchKey || ''
        })
          .then(res => {
            let list = res.data.data
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone}`
            })
            this.responsiblePersonList = list
          })
      },

      toManagePage () {
        this.$router.push({
          name: 'transmission-device'
        })
      },

      confirm () {
        if (!this.formData.deviceName) {
          nError('请输入设备名称')
          return false
        }
        if (!this.formData.deviceCode) {
          nError('请输入设备编号')
          return false
        }
        this.deviceManufacturerList.map(v => {
          if (v.code === this.formData.deviceManufacturerCode) {
            this.formData.deviceManufacturerName = v.name
          }
        })
        // this.deviceModelList.map(v => {
        //   if (v.code === this.formData.deviceModelCode) {
        //     this.formData.deviceModelName = v.name
        //   }
        // })
        this.buildingList.map(v => {
          if (v.code === this.formData.buildingCode) {
            this.formData.buildingName = v.name
          }
        })
        // this.floorList.map(v => {
        //   if (v.code === this.formData.floorCode) {
        //     this.formData.floorName = v.name
        //   }
        // })
        // this.responsiblePersonList.map(v => {
        //   if (v.code === this.formData.responsiblePersonCode) {
        //     this.formData.responsiblePersonName = v.name
        //   }
        // })
        this.$axios.post(api.updateTransmissionDevice, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toManagePage()
      }
    },
    watch: {
      'formData.buildingCode': {
        handler(newName, oldName) {
          this.buildingList.map(v => {
            if (v.code === this.formData.buildingCode) {
              this.floorList = v.floors
            }
          })
        },
        deep: true
      },
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 28px;
    line-height: 40px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .invoice-tax-rate-add {
    .el-switch {
      height: 30px;
    }
    .el-input-number.is-controls-right .el-input__inner {
      text-align: left;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/FireControl/FireControlDeviceManage/TransmissionDeviceManage/TransmissionDeviceModify.vue